(function () {
  'use strict';

  const STORAGE_KEY = 'shabbat-overlay:v1';
  const API_URL = 'https://www.hebcal.com/shabbat?cfg=json&geonameid=293397&m=50';
  const TIMEZONE = 'Asia/Jerusalem';

  function isTestMode() {
    return new URLSearchParams(window.location.search).has('shabbat_test');
  }

  function isDesignMode() {
    return window.Shopify && Shopify.designMode;
  }

  function isHebrewStorefront() {
    const lang = (document.documentElement.lang || '').toLowerCase();
    return lang === 'he' || lang === 'he-il' || lang.startsWith('he-');
  }

  function readCache() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) return null;

      const cached = JSON.parse(raw);
      if (!cached.candleLighting || !cached.havdalah || Date.now() > cached.expiresAt) {
        sessionStorage.removeItem(STORAGE_KEY);
        return null;
      }

      return cached;
    } catch (error) {
      sessionStorage.removeItem(STORAGE_KEY);
      return null;
    }
  }

  function writeCache(times) {
    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(times));
    } catch (error) {
      /* sessionStorage unavailable */
    }
  }

  function parseHebcalResponse(data) {
    if (!data || !Array.isArray(data.items)) return null;

    const candleItem = data.items.find((item) => item.category === 'candles');
    const havdalahItem = data.items.find((item) => item.category === 'havdalah');

    if (!candleItem || !havdalahItem) return null;

    const havdalahMs = new Date(havdalahItem.date).getTime();

    return {
      candleLighting: candleItem.date,
      havdalah: havdalahItem.date,
      expiresAt: havdalahMs + 60 * 60 * 1000
    };
  }

  async function fetchShabbatTimes() {
    const cached = readCache();
    if (cached) return cached;

    const response = await fetch(API_URL);
    if (!response.ok) throw new Error('HebCal request failed');

    const data = await response.json();
    const times = parseHebcalResponse(data);
    if (!times) throw new Error('HebCal response missing Shabbat times');

    writeCache(times);
    return times;
  }

  function isShabbatNow(times) {
    const now = Date.now();
    const candleMs = new Date(times.candleLighting).getTime();
    const havdalahMs = new Date(times.havdalah).getTime();

    return now >= candleMs && now < havdalahMs;
  }

  function formatHavdalahTime(isoDate) {
    return new Date(isoDate).toLocaleTimeString('he-IL', {
      timeZone: TIMEZONE,
      hour: '2-digit',
      minute: '2-digit',
      hour12: false
    });
  }

  function lockPage() {
    document.documentElement.classList.add('shabbat-overlay-locked');
  }

  function showOverlay(times) {
    const overlay = document.getElementById('shabbat-overlay');
    const havdalahEl = overlay && overlay.querySelector('[data-shabbat-havdalah-time]');

    if (!overlay || !havdalahEl) return;

    havdalahEl.textContent = formatHavdalahTime(times.havdalah);
    overlay.classList.add('shabbat-overlay--active');
    overlay.removeAttribute('hidden');
    overlay.setAttribute('aria-hidden', 'false');
    lockPage();
  }

  async function init() {
    if (isDesignMode() && !isTestMode()) return;

    const overlay = document.getElementById('shabbat-overlay');
    if (!overlay) return;

    if (isTestMode()) {
      showOverlay({ havdalah: new Date(Date.now() + 3600000).toISOString() });
      return;
    }

    if (!isHebrewStorefront()) return;

    try {
      const times = await fetchShabbatTimes();
      if (isShabbatNow(times)) {
        showOverlay(times);
      }
    } catch (error) {
      /* Fail open — never block the store if HebCal is unavailable */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
